module.exports = __webpack_public_path__ + "static/media/checklist.7ef261cc.svg";